<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid v-if="reservation.show || 1">
                              <v-layout row wrap v-if="reservation.hotel">
                                  <v-col cols="4"
                                         class="ma-0 pa-0 d-md-none"><b>Reference</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0 d-md-none">{{ reservation.reference }}</v-col>

                                  <v-col cols="4"
                                         class="ma-0 pa-0"><b>Property</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">{{ reservation.hotel.hotel_name }}</v-col>

                                  <v-col cols="4" class="ma-0 pa-0"><b>Client</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">{{ reservation.user.first_name }} {{ reservation.user.last_name }}</v-col>

                                  <v-col cols="4" class="ma-0 pa-0"><b>Status</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">{{ statusName(reservation.status_key) }}</v-col>

                                  <v-col cols="4" class="ma-0 pa-0"><b>Enquiry</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">{{ dateFormatDDMYYYYDay(reservation.last_action_update_date) }} {{ reservation.last_action_update_time }}</v-col>

                                  <v-col cols="4" class="ma-0 pa-0"><b>Arriving</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">{{ arrivalDate }}</v-col>

                                  <v-col cols="4" class="ma-0 pa-0"><b>Leaving</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">{{ departureDate }}</v-col>

                                  <v-col cols="4" class="ma-0 pa-0"><b>Stay Length</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">{{ reservation.stay_length }}</v-col>

                                  <v-col cols="4" class="ma-0 pa-0"><b>Total Guests</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">{{ totalGuests(reservation) }}</v-col>

                                  <v-col cols="4" class="ma-0 pa-0"><b>Rooms Requested</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">
                                      <ul>
                                          <li v-for="unit in reservation.units">{{ roomRequested(unit) }}</li>
                                      </ul>
                                  </v-col>

                                  <v-col cols="4" class="ma-0 pa-0"><b>Arrival Time</b></v-col>
                                  <v-col cols="8" class="ma-0 pa-0">{{ reservation.estimated_arrival }}</v-col>

                              </v-layout>
                          </v-container>
                      </v-card-text>
                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user manage a reservations
     * by the ID specified
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */

    import axios from 'axios';
    import EventBus from '@/eventBus';
    export default {
        name: 'hotel-reservation-enquiry',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {},
            }
        },
        methods: {


            /**
             * Register event listener that will be listening for clearSelector event to clear it's selected state
             */
            setUpEventListener() {
                EventBus.$on('Reservation Administration: Reservation changed', this.onReservationChanged);
            },

            /**
             * @method onReservationChanged
             * 
             * Respond to the reservation having been edited
             * by checking if the event is talking about this reservation,
             * and if so then reload it afresh so we are displaying all of
             * the correct data across the board
             * 
             * @param payload 
             */
            onReservationChanged(payload){
                if (payload.reservationKey == this.reservationkey){
                   this.loadReservation();
                }
            },

            loadReservation(){
                console.log(this.reservationkey);
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;
                    console.log("RESERVATION overview: ", this.reservation);
                }.bind(this));
            },

            statusName(){
                switch(this.reservation.status_key){
                    case 8: return "New Enquiry";
                    case 9: return "Completed";
                    case 10: return "Re-enquiry";
                    case 11: return "Availability Confirmed";
                    case 12: return "Reservation Confirmed";
                    case 13: return "Quote Accepted";
                    case 14: return "Quote Expired";
                    case 15: return "Quote Declined";
                    case 16: return "No Availability";
                    case 17: return "New Cancellation";
                    case 18: return "Cancellation Confirmed";
                    case 19: return "Declination Confirmed";
                    case 20: return "Alternative Offered";
                }
                return "Unknown";
            },

            /**
             * @method dateFormatDDMYYYYDay
             *
             * Takes a date string in the format YYYY-MM-DD and returns it in the designed format
             * e.g. '17 September 2025, Wednesday'
             *
             * @param String dateString
             * @return String
             */
            dateFormatDDMYYYYDay(dateString){
               var myDate = new Date(dateString);
               return myDate.getDate() + " " + this.getMonthName(myDate.getMonth()) + " " + myDate.getFullYear() + ", " + this.getDayName(myDate.getDay());
            },

            getMonthName(monthIndex){
                switch(monthIndex){
                    case 0: return "January";
                    case 1: return "February";
                    case 2: return "March";
                    case 3: return "April";
                    case 4: return "May";
                    case 5: return "June";
                    case 6: return "July";
                    case 7: return "August";
                    case 8: return "September";
                    case 9: return "October";
                    case 10: return "November";
                    case 11: return "December";
                }
                return "Unknown";
            },

            getDayName(dayIndex){
                switch(dayIndex){
                    case 0: return "Sunday";
                    case 1: return "Monday";
                    case 2: return "Tuesday";
                    case 3: return "Wednesday";
                    case 4: return "Thursday";
                    case 5: return "Friday";
                    case 6: return "Saturday";
                }
                return "Unknown";
            },

            totalGuests(reservation){
                console.log("totalguests", reservation);
                // Establish the total numbers of each age range per room
                var guests = {adults: 0, children: 0, oldchildren: 0, babies: 0};
                reservation.units.forEach(function(unit){
                    guests.adults += unit.occ_adults;
                    guests.oldchildren += unit.occ_oldchildren; 
                    guests.children += unit.occ_children;
                    guests.babies += unit.occ_babies;
                });
 
                // Establish the data in a human readable string
                var guestString = "";
                if (guests.adults){
                    guestString = guests.adults + " " + (guests.adults === 1 ? "adult" : "adults");
                }
                if (guests.oldchildren){
                    guestString += (guestString ? ", " : "") + guests.oldchildren + " " + (guests.oldchildren === 1 ? "old child" : "old children");
                }
                if (guests.child){
                    guestString += (guestString ? ", " : "") + guests.child + " " + (guests.child === 1 ? "child" : "children");
                }
                if (guests.babies){
                    guestString += (guestString ? ", " : "") + guests.babies + " " + (guests.babies === 1 ? "baby" : "babies");
                }
                return guestString;
            },

            roomRequested(unit){
                console.log("rooms req", unit);
                var roomsString = "";
                    var guestString = "";
                    if (unit.occ_adults){
                        guestString += unit.occ_adults + " " + (unit.occ_adults === 1 ? "adult" : "adults");
                    }
                    if (unit.occ_oldchildren){
                        guestString += (guestString ? ", " : "") + unit.occ_oldchildren + " " + (unit.occ_oldchildren === 1 ? "old child" : "old children");
                    }
                    if (unit.occ_children){
                        guestString += (guestString ? ", " : "") + unit.occ_children + (unit.occ_children === 1 ? "child" : "children");
                    }
                    if (unit.occ_babies){
                        guestString += (guestString ? ", " : "") + unit.occ_babies + (unit.occ_babies === 1 ? "baby" : "babies");
                    }
                    
                    roomsString += "1x " + unit.room.name + " (" + guestString + ") " + (unit.rate_type ? " " + unit.rate_type.name : "");

                return roomsString;
            }
        },

        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
            this.setUpEventListener();
        },

        computed: {
            arrivalDate: function(){ 

                console.log("arrival date", this.reservation.date_arrival);
                return this.dateFormatDDMYYYYDay(this.reservation.date_arrival);
            },
            departureDate: function(){ return this.dateFormatDDMYYYYDay(this.reservation.date_departure); }
        }
    }
</script>
